import GenericComposedChart, {
  MAX_BAR_SIZE,
  renderCustomBar,
} from "reports/components/Reports/GenericCharts/BarCharts/GenericComposedChart";
import { RightBarLabel } from "reports/components/Reports/RechartHelpers/RechartBarLabels";
import { Bar, LabelList } from "recharts";

const CHART_HEIGHT = 800;
export default function PciukWeeklySkuChart({
  chartData,
  width,
  color,
  metricTitle,
}: {
  chartData: { sku: string; metric: number }[];
  width: number;
  color: string;
  metricTitle: string;
}) {
  const bars = [
    {
      name: metricTitle,
      dataKey: "metric",
      fill: color,
    },
  ];

  const customBars = bars.map(bar => {
    return (
      <Bar
        key={bar.dataKey}
        {...bar}
        shape={renderCustomBar(CHART_HEIGHT)}
        isAnimationActive={false}
        maxBarSize={MAX_BAR_SIZE}
      >
        <LabelList
          dataKey={"metric"}
          content={RightBarLabel({ suffix: "%" })}
        />
      </Bar>
    );
  });

  return (
    <GenericComposedChart
      width={width}
      data={chartData}
      bars={[]}
      customBars={customBars}
      xLabel={""}
      xKey={"percent"}
      yKey={"sku"}
      yLabel={""}
      height={CHART_HEIGHT}
      vertical={true}
      yAxisMaxCharsPerLine={64}
    />
  );
}
